/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Activity20 = (props: SVGProps) => (
    <AccessibleSVG viewBox="0 0 20 20" width={20} height={20} {...props}>
        <path
            d="M12 1a8 8 0 110 16h-2l-5.606 2.403A1 1 0 013 18.483v-3.237A8 8 0 018 1h4zM6 8a1 1 0 100 2 1 1 0 000-2zm4 0a1 1 0 100 2 1 1 0 000-2zm4 0a1 1 0 100 2 1 1 0 000-2z"
            fill={vars.bdlGray50}
        />
    </AccessibleSVG>
);

export default Activity20;
